import { FaCheckCircle } from 'react-icons/fa';
import { getProviderInfo } from './providerMap';

export function buildJobMeta(job, resultsMeta = {}) {
  const provider = getProviderInfo(job?.provider);
  const model = job?.selectedModel || resultsMeta?.modelName || '—';
  const status = job?.status || 'unknown';
  const cost = typeof job?.actualCost === 'number' ? job.actualCost : null;
  // Get target SCOPES from job configuration, not individual detected items from results
  const targetsArr = job?.analysisRequest?.targets || job?.selectedTargets || job?.selectedServices || resultsMeta?.targets || [];
  
  // Handle targets - convert to string safely
  let targets = '';
  if (Array.isArray(targetsArr) && targetsArr.length > 0) {
    // Debug: Log target structure
    if (targetsArr.some(t => typeof t === 'object' && t !== null)) {
      console.log('🎯 Target objects detected:', targetsArr);
    }
    
    // Map targets to strings, handling both string and object formats
    const targetStrings = targetsArr.map(t => {
      if (typeof t === 'string') {
        return t;
      } else if (typeof t === 'object' && t !== null) {
        // If target is an object, try to get a name/label property
        return t.name || t.label || t.id || t.type || JSON.stringify(t);
      }
      return String(t);
    });
    targets = targetStrings.join(', ').replaceAll('_', ' ');
  } else if (typeof targetsArr === 'string') {
    targets = targetsArr.replaceAll('_', ' ');
  }
  
  return { provider, model, status, cost, targets };
}

export function MetaRow({ label, children }) {
  return (
    <div style={{ fontSize: 12 }}>
      <span style={{ opacity: 0.7 }}>{label}</span>{' '}
      <span style={{ fontWeight: 600 }}>{children}</span>
    </div>
  );
}

export function AuthBadge() {
  return (
    <span style={{ color: '#22c55e', display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 12 }}>
      <FaCheckCircle style={{ fontSize: 10 }} /> Verified API Response
    </span>
  );
}


